import React from 'react';
import { AlertTriangle } from 'lucide-react';
export function CalloutWarning({
  children
}: {
  children: ReactNode;
}) {
  return <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 flex gap-3 items-start" data-id="element-204">
      <AlertTriangle className="text-amber-500 shrink-0 mt-0.5" size={18} data-id="element-205" />
      <div className="text-sm text-amber-900" data-id="element-206">{children}</div>
    </div>;
}